import { BookMarked } from "lucide-react";

/**
 * Partial UI fragments for the homepage hero — intentionally incomplete so
 * competitors cannot reconstruct the full product layout from marketing.
 */
export function HomeProductPeek() {
  return (
    <div className="relative z-[1] mx-auto h-[320px] max-w-[920px] px-6 pb-20 md:h-[320px]">
      <div className="absolute inset-0" aria-hidden>
        {/* Metric tile */}
        <div className="peek-card absolute left-[8%] top-5 w-[200px] -rotate-2 rounded-[14px] border border-border bg-surface p-5 shadow-[0_8px_24px_rgba(15,23,42,0.07)] max-md:left-[4%] max-md:top-2.5 max-md:scale-90 max-md:-rotate-1">
          <div className="text-[2rem] font-semibold tracking-tightest text-forest-700">18</div>
          <div className="mt-0.5 text-xs text-ink-400">Flags this review</div>
          <div className="mt-3 h-1 overflow-hidden rounded-sm bg-ink-100">
            <div className="h-full w-[72%] rounded-sm bg-forest-100" />
          </div>
        </div>

        {/* Single flag row */}
        <div className="peek-card absolute left-1/2 top-[60px] w-[min(420px,90vw)] -translate-x-1/2 overflow-hidden rounded-[14px] border border-border bg-surface shadow-[0_8px_24px_rgba(15,23,42,0.07)]">
          <div className="border-b border-border bg-ink-50 px-4 py-2.5 text-[0.7rem] font-semibold uppercase tracking-wider text-ink-400">
            Clinical flag
          </div>
          <div className="p-4 md:px-5">
            <div className="flex items-start gap-3">
              <span className="mt-1.5 h-2 w-2 shrink-0 rounded-full bg-red-500" />
              <span className="max-w-[260px] flex-1 truncate text-[0.8125rem] font-medium text-ink-800">
                Anticholinergic burden threshold…
              </span>
              <span className="font-mono text-[0.7rem] text-ink-400">ACB</span>
            </div>
            <div className="pointer-events-none mt-3 flex select-none flex-col gap-2 blur-[5px]">
              <div className="h-3 w-[88%] rounded bg-ink-100" />
              <div className="h-3 w-[72%] rounded bg-ink-100" />
              <div className="h-3 w-[80%] rounded bg-ink-100" />
            </div>
          </div>
        </div>

        {/* Status pill card */}
        <div className="peek-card absolute right-[2%] top-[30px] w-[180px] rotate-2 rounded-[14px] border border-border bg-surface p-4 shadow-[0_8px_24px_rgba(15,23,42,0.07)] max-md:right-[4%] max-md:top-2.5 max-md:scale-90 max-md:rotate-1">
          <div className="mb-3 inline-flex items-center gap-1.5 rounded-[5px] border border-red-200 bg-red-50 px-2.5 py-1 text-[0.7rem] font-semibold text-red-700">
            <span className="h-1.5 w-1.5 rounded-full bg-red-500" />
            Critical
          </div>
          <div className="mb-1.5 h-2 rounded-sm bg-ink-100" />
          <div className="mb-1.5 h-2 w-[70%] rounded-sm bg-ink-100" />
          <div className="h-2 w-[85%] rounded-sm bg-ink-100" />
        </div>

        {/* Citation chip */}
        <div className="peek-card absolute bottom-10 left-[14%] flex -rotate-1 items-center gap-2.5 rounded-[14px] border border-border bg-surface px-4 py-2.5 shadow-[0_8px_24px_rgba(15,23,42,0.07)] max-md:hidden">
          <div className="flex h-7 w-7 items-center justify-center rounded-md border border-forest-100 bg-forest-50 text-forest-700">
            <BookMarked className="h-3.5 w-3.5" aria-hidden />
          </div>
          <div className="text-xs text-ink-600">
            <strong className="font-semibold text-ink-900">Evidence cited</strong>
            <br />
            per rule
          </div>
        </div>

        {/* Edge fragment */}
        <div className="peek-card absolute bottom-20 -right-10 hidden h-[100px] w-40 rounded-l-[14px] border border-r-0 border-border bg-ink-50 opacity-70 md:block">
          <div className="m-4 h-2 w-[60%] rounded-sm bg-ink-200" />
        </div>

        {/* Bottom fade */}
        <div className="pointer-events-none absolute bottom-0 left-0 right-0 z-10 h-[120px] bg-gradient-to-b from-transparent to-surface" />
      </div>

      <p className="absolute bottom-6 left-1/2 z-[11] -translate-x-1/2 whitespace-nowrap text-center text-xs text-ink-400">
        Product previews are intentionally partial — book a demo to see the full platform.
      </p>
    </div>
  );
}
